exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".pill{display:inline-block;padding:4px 10px;border-radius:20px;font-size:12px;font-weight:700;color:#fff;text-align:center}.pill-sm{padding:2px 8px;font-size:10px}.rojo{background-color:#e3342f}.verde{background-color:#38c172}", ""]);

// exports
